export default class Notes {
    constructor() {
        if (!document.getElementById('dlg_addNotes')) {
            return;
        }
        const _this = this;
        const dlg_addNote = $('#dlg_addNotes').dialog({
            autoOpen: false,
            modal: true,
            width: 600,
            title: 'Notizen',
            height: 250,
            maxHeight: 600,
            buttons: [
                {
                    text: 'Ok',
                    class: 'ok',
                    click: function () {
                        var _this = this;
                        $.ajax({
                            cache: false,
                            type: 'POST',
                            url: '/Handler/Notes',
                            dataType: 'JSON',
                            data: {
                                data: {
                                    action: 'create',
                                    note: document.getElementById('edit-note').innerHTML
                                }
                            }
                        }).done(function (data) {
                            if (data.done) {
                                var notesList = document.querySelector('.list.notes');
                                /** @type {HTMLDivElement} */
                                var newRow = document.createElement('div');

                                newRow.classList.add('row');
                                newRow.classList.add('normal');
                                newRow.classList.add('equal');
                                newRow.innerHTML =
                                    '<div class="col-xs-9" title="Erstellt: {$note->created|date_format:"%d.%m.%Y %H:%M:%S"}"></div><div class="col-xs-2"></div><div class="col-xs-1"><i class="icon-trash pointer" data-uid=""></i></div>';
                                var columns = <NodeListOf<HTMLElement>>(
                                    newRow.querySelectorAll('[class*="col-xs"]')
                                );
                                columns[0].innerHTML = data.note;
                                var dt = new Date(data.created);
                                var formatedDt = new Intl.DateTimeFormat('de', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit'
                                }).format(dt);
                                columns[0].title = 'Erstellt: ' + formatedDt;
                                columns[1].innerHTML = data.user;
                                columns[2].querySelector('i').dataset.uid = data.id;
                                notesList.insertAdjacentElement('afterbegin', newRow);
                                $(_this).dialog('close');
                                newRow
                                    .querySelector('.list.notes .icon-trash')
                                    .addEventListener('click', function () {
                                        _this.rmNote(this);
                                    });
                            }
                        });
                    }
                },
                {
                    text: 'Abbrechen',
                    class: 'cancel',
                    click: function () {
                        $(this).dialog('close');
                    }
                }
            ]
        });
        document.querySelector('.addNote').addEventListener('click', function () {
            dlg_addNote.dialog('open');
        });
        document.querySelectorAll('.list.notes .icon-trash').forEach(
            /** @param {HTMLElement} el */ function (el) {
                el.addEventListener('click', function () {
                    _this.removeNote(el);
                });
            }
        );
    }

    /**
     *
     * @param {HTMLElement} el
     */
    removeNote(el) {
        if (confirm('Notiz löschen?')) {
            $.ajax({
                cache: false,
                type: 'POST',
                url: '/Handler/Notes',
                dataType: 'JSON',
                data: {
                    data: {
                        action: 'del',
                        uid: el.dataset.uid
                    }
                }
            }).done(function (data) {
                if (data.done) {
                    el.closest('.row').remove();
                }
            });
        } else {
        }
    }
}
